import { render, staticRenderFns } from "./ChangeAreaNameModal.vue?vue&type=template&id=045874fb"
import script from "./ChangeAreaNameModal.vue?vue&type=script&lang=ts"
export * from "./ChangeAreaNameModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports